/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Imaad Shadab",
  title: "Hi, I'm Imaad Shadab",
  subTitle:
    "Software Developer transitioning into AI/ML, with experience building full-stack applications, enterprise systems, and machine learning solutions using Python and modern development technologies.",
  resumeLink:
    "https://drive.google.com/file/d/1mSGCw5DNvmN1x1BVzlWQvv7F-ThnixTl/view", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  linkedin: "https://linkedin.com/in/imaadshadab/",
  gmail: "imaadshad13@gmail.com",
  github: "https://github.com/imaadShadab",
  stackoverflow: "https://stackoverflow.com/users/17785103/pip-install-logic",
  twitter: "https://x.com/imaadshadab",

  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Building Systems, Understanding the Foundations",
  subTitle:
    "Software developer building full-stack applications, enterprise systems, and machine learning solutions.",

  skills: [
    "Build full-stack web applications and backend systems using Python, Django, React, and modern development tools",
    "Develop enterprise software and ERP systems that automate business workflows",
    "Implement machine learning algorithms from first principles and explore their mathematical foundations"
  ],

  softwareSkills: [
    {skillName: "Python", fontAwesomeClassname: "fab fa-python"},
    {skillName: "Django", fontAwesomeClassname: "fas fa-code"},
    {skillName: "PyTorch", fontAwesomeClassname: "fas fa-project-diagram"},
    {skillName: "JavaScript", fontAwesomeClassname: "fab fa-js"},
    {skillName: "React", fontAwesomeClassname: "fab fa-react"},
    {skillName: "SQL Databases", fontAwesomeClassname: "fas fa-database"},
    {skillName: "Git", fontAwesomeClassname: "fab fa-git-alt"},

  ],

  display: true
};

// Education Section

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Rochester Institute of Technology",
      logo: require("./assets/images/rit.png"), // add later if you want
      subHeader:
        "Bachelor of Science in Computing and Information Technologies",
      duration: "September 2023 - Present",
      desc: "Focused on software development and modern computing technologies. Current GPA: 3.54/4.0",
      descBullets: [
        "Awarded Dean's List recognition 4 times for academic excellence",
        "Actively involved in technical projects and innovation competitions"
      ]
    },

    {
      schoolName: "Stanford University - SEE",
      logo: require("./assets/images/stanford.jpg"),
      subHeader: "CS229: Machine Learning",
      duration: "Completed 2026",
      desc: "Completed Stanford's CS229 Machine Learning course, studying the mathematical foundations and implementation of modern machine learning algorithms through lectures, derivations, and practical programming.",
      descBullets: [
        "Built a companion GitHub repository implementing core ML algorithms from scratch in Python, emphasizing the mathematical foundations.",
        "Created interactive visualizations with Matplotlib to illustrate algorithm behavior, for deeper conceptual understanding"
      ]
    },

    {
      schoolName: "MIT OpenCourseWare",
      logo: require("./assets/images/MIT.png"),
      subHeader: "18.06 Linear Algebra",
      duration: "Completed 2026",
      desc: "Completed the MIT OpenCourseWare version of 18.06 Linear Algebra, studying fundamental concepts including matrices, vector spaces, eigenvalues, eigenvectors, orthogonality, and linear transformations.",
      descBullets: [
        "Studied lectures and problem sets based on MIT's undergraduate Linear Algebra curriculum",
        "Strengthened mathematical foundations for machine learning, optimization, and computer science"
      ]
    },

    {
      schoolName: "LearnPyTorch.io",
      logo: require("./assets/images/pytorch.png"),
      subHeader: "PyTorch for Deep Learning",
      duration: "Completed 2026",
      desc: "Completed the Learn PyTorch for Deep Learning curriculum, developing practical experience building, training, evaluating, and deploying deep learning models with PyTorch across neural networks, computer vision, transfer learning, and custom datasets.",
      descBullets: [
        "Built and trained neural networks for regression, classification, and computer vision tasks using PyTorch",
        "Worked with custom datasets, modular model development, transfer learning, experiment tracking, and model deployment"
      ]
    },

    {
      schoolName: "International Indian School, Jeddah",
      logo: require("./assets/images/school.png"),
      subHeader: "CBSE",
      duration: "2009 - 2023",
      desc: "Completed CBSE with 93%, demonstrating strong academic performance and foundation.",
      descBullets: [
        "Achieved First Position in the batch",
        "Secured 1st place in Marketing Subject"
      ]
    },

    {
      schoolName: "Ethical Hacking From Scratch",
      logo: require("./assets/images/zsec.png"),
      subHeader: "zSecurity (Zaid Sabih)",
      duration: "2022",
      desc: "Completed a comprehensive practical course in ethical hacking and cybersecurity, focusing on practical network hacking, penetration testing techniques and system security.",
      descBullets: [
        "Gained experience in network hacking including WiFi security, ARP spoofing, and MITM attacks",
        "Worked with industry tools such as Metasploit, Nmap, Wireshark, and SQLmap",
        "Learned server-side and client-side attack methodologies and vulnerability assessment",
        "Explored web application security including SQL Injection and Cross-Site Scripting (XSS)"
      ]
    },
    {
      schoolName: "Python & Blockchain Development",
      logo: require("./assets/images/python.png"),
      subHeader: "Academind (Maximilian Schwarzmüller)",
      duration: "2019",
      desc: "Completed Python course focused on building real-world applications, including developing a custom blockchain and understanding its core concepts.",
      descBullets: [
        "Learned Python fundamentals including data structures, functions, loops, and OOP",
        "Built a blockchain and cryptocurrency system from scratch using Python",
        "Worked with files, error handling, debugging, and modular programming",
        "Gained foundational knowledge of blockchain concepts and decentralized systems"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false,
  experience: [
    {
      Stack: "ERP Systems & Backend Automation",
      progressPercentage: "85%"
    },
    {
      Stack: "Web Development",
      progressPercentage: "80%"
    },
    {
      Stack: "Machine Learning & Mathematical Foundations",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false
};

// Work Exp

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Full-Stack Developer",
      company: "Dinar Jewellery",
      companylogo: require("./assets/images/logo.png"), // optional for now
      date: "May 2022 - Sep 2022",
      desc: "Developed a full-stack ERP system using Django to streamline business operations and automate accounting processes.",
      descBullets: [
        "Designed and implemented backend architecture using Django and Python",
        "Automated complex accounting workflows, reducing manual workload",
        "Collaborated with stakeholders to build a system tailored to business needs"
      ]
    },

    {
      role: "Lead 3D Printer Operator",
      company: "Dinar Jewellery",
      companylogo: require("./assets/images/logo.png"),
      date: "Aug 2020 - Jan 2022",
      desc: "Managed end-to-end 3D printing operations for jewelry manufacturing, ensuring precision and production efficiency.",
      descBullets: [
        "Handled CAD file preparation and optimized designs for printing",
        "Operated and maintained 3D printers for high-precision output",
        "Improved production workflow and product quality through process optimization"
      ]
    },

    {
      role: "Digital Assets Trader",
      company: "Self-Employed",
      companylogo: require("./assets/images/trading.png"),
      date: "2021 - Present",
      desc: "Actively trade digital assets with a strong focus on data-driven decision-making, risk management, and market analysis.",
      descBullets: [
        "Analyzed market trends and price action to make informed trading decisions",
        "Developed strong risk management strategies to optimize returns and minimize losses",
        "Gained deep understanding of trading platforms and financial market behavior"
      ]
    },
    {
      role: "Secretary",
      company: "RIT Chess Club",
      companylogo: require("./assets/images/rit.png"),
      date: "Aug 2024 - Jan 2025",
      desc: "Managed communication and coordination within the club, ensuring smooth execution of activities and events.",
      descBullets: [
        "Recorded and maintained detailed meeting minutes",
        "Facilitated communication between members and leadership",
        "Organized and coordinated club activities effectively"
      ]
    },
    {
      role: "Peer Tutor - English",
      company: "RIT Liberal Arts",
      companylogo: require("./assets/images/rit.png"),
      date: "2023 - 2024",
      desc: "Supported students in improving academic writing and communication skills.",
      descBullets: [
        "Guided students in academic writing and language skills",
        "Explained complex concepts in a clear, structured way",
        "Strengthened communication and mentoring abilities"
      ]
    }
  ]
};
/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "Real-world systems and innovative solutions I have worked on",
  projects: [
    {
      image: require("./assets/images/logo.png"),
      projectName: "ERP System (Django)",
      projectDesc:
        "Developed a full-stack ERP system for a jewelry business to automate accounting and operational workflows. The system streamlined complex processes and significantly reduced manual workload.",
      footerLink: [
        {
          name: "Private Project",
          url: ""
        }
      ]
    },
    {
      image: require("./assets/images/ml.webp"),
      projectName: "Machine Learning Foundations",
      projectDesc:
        "An educational repository where I implement machine learning algorithms from scratch in Python and use Matplotlib visualizations to strengthen my understanding of their mathematical foundations.",
      footerLink: [
        {
          name: "View GitHub Repository",
          url: "https://github.com/imaadShadab/Machine_Learning-Foundations"
        }
      ]
    },

    {
      image: require("./assets/images/genryptor.png"), // optional
      projectName: "Genryptor",
      projectDesc:
        "Developed a secure password manager using Django to store and retrieve encrypted credentials. The credentials are secured using symmetric key encryption and a password generator.",
      footerLink: [
        {
          name: "View Github Repository",
          url: "https://github.com/imaadShadab/Genryptor"
        }
      ]
    },
    {
      image: require("./assets/images/peg-game.png"),
      projectName: "Peg Solitaire",
      projectDesc:
        "Developed a Java implementation of the Peg Solitaire game with both command-line and JavaFX graphical interfaces. Implemented game logic and board configuration through files.",
      footerLink: [
        {
          name: "View GitHub Repository",
          url: "https://github.com/imaadShadab/Java-PegGame"
        }
      ]
    },
    {
      image: require("./assets/images/ai.png"),
      projectName: "SolarGuard: AI Solar Optimization System",
      projectDesc:
        "Proposed and developed an AI-driven solution using Digital Twins to optimize solar panel efficiency in harsh environments. Built as part of a hackathon-winning sustainability project.",
      footerLink: [
        {
          name: "View Case Study",
          url: "https://drive.google.com/file/d/1ix3ISl8w_k7wmfbRMLlzkGpKAtIz3BEy/view?usp=sharing"
        }
      ]
    },
    {
      image: require("./assets/images/service.png"), // optional
      projectName: "Service Design Innovation",
      projectDesc:
        "Developed an innovative solution to simplify the driving license process, winning 1st place in a service design competition. Focused on improving user experience and optimizing system efficiency.",
      footerLink: [
        {
          name: "View Solution",
          url: "https://drive.google.com/file/d/1LlUxDy-a4M2capq0AwKE3164BYw1rDHf/view?usp=sharing"
        }
      ]
    }
  ],
  display: true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: "Achievements & Awards",
  subtitle:
    "Recognition for innovation, technical excellence, and problem-solving",

  achievementsCards: [
    {
      title: "1st Place - Energy Efficient Innovation Hackathon",
      subtitle:
        "Won first place for developing an AI-driven solution using Digital Twins to optimize solar panel efficiency in harsh environmental conditions.",
      image: require("./assets/images/econova_cert.png"), // optional
      imageAlt: "Hackathon Award",
      footerLink: []
    },
    {
      title: "1st Place - Service Design Competition",
      subtitle:
        "Designed an innovative solution to simplify the driving license process, focusing on user experience and system efficiency.",
      image: require("./assets/images/hnw_cert.png"),
      imageAlt: "Service Design Award",
      footerLink: []
    },
    {
      title: "Dean's List (4x)",
      subtitle:
        "Awarded Dean's List recognition four times for consistent academic excellence at Rochester Institute of Technology.",
      image: require("./assets/images/deans.png"),
      imageAlt: "Academic Achievement",
      footerLink: []
    },
    {
      title: "1st Place - Intercollege Chess Tournament",
      subtitle:
        "Secured first place in an inter-college chess tournament, demonstrating strong strategic thinking, decision-making, and competitive skills.",
      image: require("./assets/images/chess.png"), // change if you have a chess-specific image
      imageAlt: "Chess Tournament Achievement",
      footerLink: []
    }
  ],
  display: true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Get In Touch 👋"),
  subtitle:
    "Open to opportunities, collaborations, and building impactful tech solutions.",
  number: "+971 543770789",
  email_address: "imaadshad13@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
